import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course02 from "../../../course/course-02/course";
import lesson0214 from "../../course-02/lesson-14/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "c0362d8e-b2a1-43a9-9437-908abbd9eeac",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0214),
    lesson: lesson0214,
  },
];

export default lessonLinks;
